"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _dynamicModifiers = require("../../utils/dynamicModifiers");

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _styleModifiers = require("../../utils/styleModifiers");

var _Slider = require("./Slider");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedInactiveStyles = function sharedInactiveStyles(_ref) {
  var position = _ref.position;
  return (0, _styledComponents.css)(["cursor:not-allowed;", "{", ";}&:active,&:focus{", "{border:1px solid transparent;", ";}}&:hover{", "{box-shadow:none;}}*{cursor:not-allowed;}"], _Slider.SliderContainer, position === 'left' ? (0, _styledComponents.css)(["opacity:0.15;"]) : (0, _styledComponents.css)(["background-color:rgb(179,215,197);"]), _Slider.SliderContainer, (0, _focusRingWithColor.default)({
    red: 0,
    green: 0,
    blue: 0,
    alpha: 0
  }), _Slider.SliderSwitch);
};

var Fieldset = _styledComponents.default.fieldset.withConfig({
  displayName: "Fieldset",
  componentId: "jon6ft-0"
})(["display:inline-block;border-width:0;padding:0;margin:0;&:active,&:focus{outline:none;}&:hover{", "{box-shadow:0 0 0 ", "px rgba(37,38,46,0.15);}}&:active ", ",&:focus ", "{border:1px solid ", ";", "}&:hover ", "{background-color:toColorString(color.interaction.indianOcean)};}", "{border:1px solid transparent;}", ";", ";"], _Slider.SliderSwitch, _designTokens.spacing.base * 0.8, _Slider.SliderContainer, _Slider.SliderContainer, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), function (_ref2) {
  var position = _ref2.position;
  return position === 'left' ? (0, _focusRingWithColor.default)(_designTokens.color.interaction.pacificOcean40) : (0, _focusRingWithColor.default)(_designTokens.color.opacity.fullMoon50);
}, _Slider.SliderSwitch, _Slider.SliderContainer, (0, _dynamicModifiers.applyDynamicModifiers)('size', function (_ref3) {
  var size = _ref3.size;

  if (size === 'small') {
    return (0, _styledComponents.css)(["height:", "px;"], 8 * 2 + 2);
  }

  return (0, _styledComponents.css)(["height:", "px;"], _designTokens.spacing.base * 2 + 2);
}), function (_ref4) {
  var position = _ref4.position;
  return (0, _styleModifiers.whenSome)([['disabled', true], ['readOnly', true]], (0, _styledComponents.css)(["", ""], sharedInactiveStyles({
    position: position
  })));
});

var _default = Fieldset;
exports.default = _default;